import Control from '@/Controls/Control';
import Builder from '@/Builder/Builder';

export default abstract class ControlBuilder<T1 extends Control, T2 = null> extends Builder<T1, T2> {

    protected element: JQuery<HTMLElement>;

    protected constructor(parent?: T2) {
        super(parent);
    }

    public withElement(element: JQuery<HTMLElement>): this {
        this.element = element;
        return this;
    }

    protected preBuild(): void {
        return;
    }

    public buildAndGetElement(): JQuery<HTMLElement>  {
        const control = this.build();
        return control.getTuple().control;
    }
}